// @vendors
const Immutable = require('immutable');

// @constants
const { EURO_SYMBOL } = require('constants/index');
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    valid: true,
    submitSuccessful: false,
    hireData: {
        // @TODO: Replace this model to swagger's providedModel
        refundValue: {
            amount: 0, // @hardcoded
            currency: EURO_SYMBOL, // @hardcoded
            isDirty: false,
        },
    },
    isLoading: false,
});

function validateForm(state) {
    return state; // @hardcoded
}

const RARefundRequest = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_REFUND_REQUEST_IN_PROGRESS:
            return state.merge({
                isLoading: true,
            });
        case actionTypes.RA_REFUND_REQUEST_SUCCESS:
            return state.merge({
                submitSuccessful: true,
                isLoading: false,
            });
        case actionTypes.RA_REFUND_REQUEST_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_REFUND_REQUEST_RESET:
            return initialState;
        case actionTypes.RA_REFUND_REQUEST_VALIDATE_FORM:
            return validateForm(state);
        case actionTypes.RA_REFUND_REQUEST_SET_REFUND_AMOUNT:
            return state.mergeIn(['hireData', 'refundValue'], {
                amount: action.payload,
                isDirty: true,
            });
        default:
            return state;
    }
};

module.exports = RARefundRequest;
